import { gql } from "@apollo/client";

export const generateNoOfEntries = gql`
  query generateReportSitNaePremier($trialCalendarId: Int!) {
    generateReportSitNaePremier(trialCalendarId: $trialCalendarId) {
      downloadUrl
    }
  }
`;

export const generatePassRate = gql`
  query generatePassRateReport($trialCalendarId: Int!) {
    generatePassRateReport(trialCalendarId: $trialCalendarId) {
      downloadUrl
    }
  }
`;

export const generateTitlesReport = gql`
  query generateAllCompetitorsReport($trialCalendarId: Int!) {
    generateAllCompetitorsReportTitle(trialCalendarId: $trialCalendarId) {
      downloadUrl
    }
  }
`;

export const generateTrailDrawReport = gql`
  query GenerateAllCompetitorsReport($trialCalendarId: Int!) {
    generateAllCompetitorsReport(trialCalendarId: $trialCalendarId) {
      downloadUrl
    }
  }
`;

export const generateTitleAnalytic = gql`
  query getAllTitleAnalyticsForHostDashboardPdf {
    getAllTitleAnalyticsForHostDashboardPdf(search: "") {
      pdfUrl
    }
  }
`;

export const generateTrialAnalytic = gql`
  query GenerateTrialStatisticsReport {
    generateTrialStatisticsReport {
      downloadUrl
    }
  }
`;

export const generatePassRateReportFull = gql`
  query GeneratePassRateReportFull  {
    generatePassRateReportFull {
      downloadUrl
    }
  }
`;

export const getAndDownloadAwaitedTrialForDraw = gql`
  query getAndDownloadAwaitedTrialForDraw($trialCalendarId: Int!) {
    getAndDownloadAwaitedTrialForDraw(
      pageNumber: 1
      pageSize: 10
      trialCalendarId: $trialCalendarId
    ) {
      downloadUrl
    }
  }
`;

export const downloadScoreRoomGQL = gql`
  query GetAllScoreLis($trialCalendarId: Int!) {
    getAllScoreList(trialCalendarId: $trialCalendarId) {
      downloadUrl
    }
  }
`;

export const downloadRandomDogsTrialByTrialCalendar = gql`
  query DownloadRandomDogsTrialByTrialCalendar($trialCalendarId: Int!) {
    downloadRandomDogsTrialByTrialCalendar(trialCalendarId: $trialCalendarId) {
      totalDraw
      downloadUrl
    }
  }
`;

export const generateStickersPdfQuery = gql`
  query GenerateStickersPdf($trialCalendarId: Int!) {
    generateStickersPdf(trialCalendarId: $trialCalendarId) {
      message
      url
    }
  }
`;

export const generateTrialStatistics = gql`
  query DogResultReport4($trialCalendarId: Int!) {
    dogResultReport4(trialCalendarId: $trialCalendarId) {
      npfEntries
      standardEntriesPremier
      feoEntriesPremier
      dataExist
      trialCalendarId
      date
      totalEntryNoPremier
      trialName
      trialLocation
      totalEntries
      sitEntries
      standardEntries
      proEntries
      feoEntries
      premierFul
      premierShort
      qStandardEntries
      qProEntries
      qFeoEntries
      passRate
      totalNQ
      hideNotFound
      falseAlert
      timedOut
      noFinishCall
      excused
      absent
      other
      awards
      elementTitles
      proTitles
      noviceOverallTitle
      advancedOverallTitles
      excellentOverallTitles
      premierTitles
      championTitles
      searchEntries {
        search
        entries
        passRate
      }
    }
  }
`;



export const generateTrialResultsPremium = gql`
  query DogResultReport2($trialCalendarId: Int!) {
    dogResultReport2(trialCalendarId: $trialCalendarId) {
       trialCalendarId
        date
        trialName
        trialLocation
        awards {
          handler
          dogName
          breed
          award
        }
        premier {
          entries
          hides
          search
          data {
            dogId
            handler
            dogName
            div
            hidesFound
            faults
            faultReason
            points
            time
            place
          }
        }
        overall {
            entries
            hides
            pointsPerHide
            data {
              handler
              dogName
              breed
              points
              time
              place
            }
        }
    }
  }
`;

export const generateTrialResults = gql`
  query DogResultReport3($trialCalendarId: Int!) {
    dogResultReport3(trialCalendarId: $trialCalendarId) {
       trialCalendarId
        date
        trialName
        trialLocation
        sit {
            entries
            qRate
            search
            data {
                dogId
                handler
                dogName
                div
                qNq
                ngReason
                points
                time
                place
            }
        }
        awards {
            handler
            dogName
            breed
            award
        }
        nonPremier {
            entries
            qRate
            search
            data {
                dogId
                handler
                dogName
                div
                qNq
                ngReason
                points
                time
                place
            }
        }
    }
  }
`;


export const generatedDogResults = gql`
  query DogResultReport1($trialCalendarId: Int!) {
    dogResultReport1(trialCalendarId: $trialCalendarId) {
      trialCalendarId
        date
        trialName
        result {
          dogId
          dogName
          awards
          memberName
          data {
            search
            hidesSet
            hidesFound
            qNq
            faults
            faultReason
            points
            timeLimit
            ngReason
            time
            judgeNotes
            place
          }
        }
      }
    }
`;


export const getPotentialTitlesQuery = gql`
  query GetPotentialTitlesReport($trialCalendarId: Int!) {
      getPotentialTitlesReport(trialCalendarId: $trialCalendarId) {
        trialName
        result {
          dogId
          dogName
          handler
          search
          div
          points
          qNumber
          qNq
        }
      }
    }
`;

export const generateAllCompetitorsQuery = gql`
  query GenerateAllCompetitorsReport($trialCalendarId: Int!) {
    generateAllCompetitorsReport(trialCalendarId: $trialCalendarId) {
      downloadUrl
    }
  }
`;

export const getTrialResultDogQuery = gql`
  query GetTrialResultDog($trialCalendarId: Int!) {
      getTrialResultDog(trialCalendarId: $trialCalendarId) {
        id
        call_name
        registration_name
      }
    }
`;

export const dogResultReport5 = gql`
  query DogResultReport5($trialCalendarId: Int!) {
    dogResultReport5(trialCalendarId: $trialCalendarId) {
      trialCalendarId
      date
      trialName
      trialLocation
      data {
        dogId
        dogName
        handler
        totalPoints
        totalHidesFound
        totalFaults
        totalPlace
        result {
            searchName
            result {
              dogId
              handler
              dogName
              div
              qNq
              ngReason
              points
              time
              place
              faults
              searchName
              judgeNotes
              hidesSet
              hidesFound
              falseAlerts
              timeLimit
              timeOut
              hide1Location
              hide1Found
              hide2Location
              hide2Found
              hide3Location
              hide3Found
              hide4Location
              hide4Found
              hide5Location
              hide5Found
              hide6Location
              hide6Found
              hide7Location
              hide7Found
            }
          }
          awards {
            handler
            dogName
            breed
            award
          }
      }
    }
  }
`;
